import {Inject, Injectable} from "@angular/core";
import {MODULE_VERSIONS} from "./versions";
import {HttpHeaders} from "@angular/common/http";
import {Subject} from "rxjs";

@Injectable()
export class VersionService {
    private readonly HEADER_NAME: string = 'Accept-Version';

    public readonly versionMismatch$: Subject<void> = new Subject<void>();

    constructor(@Inject(MODULE_VERSIONS) private moduleVersions: any[]) {
    }

    public setVersionHeader(headers: HttpHeaders): HttpHeaders {
        let versionMap = {};
        this.moduleVersions.forEach(x => versionMap[x.module] = x.version);

        return headers.set(this.HEADER_NAME, JSON.stringify(versionMap));
    }
}
